import { render, staticRenderFns } from "./ClockpickerFooter.vue?vue&type=template&id=20ccddc2&scoped=true&"
import script from "./ClockpickerFooter.vue?vue&type=script&lang=js&"
export * from "./ClockpickerFooter.vue?vue&type=script&lang=js&"
import style0 from "./ClockpickerFooter.vue?vue&type=style&index=0&id=20ccddc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ccddc2",
  null
  
)

export default component.exports